import { DS_COLOR } from '@calm/evexia-design-tokens';
import { useProvidedTheme } from '@rhg/hooks/use-provided-theme';
import {
    Button,
    ButtonProps,
    IconButton,
    IconButtonProps,
    ThemeProvider,
    useTheme,
} from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';

const styleButton = (isDarkMode: boolean) => ({
    justifyContent: 'start',
    alignItems: 'center',
    py: '12px',
    height: 'auto',
    borderRadius: '100px',
    gap: 2,
    ...(isDarkMode
        ? {
              backgroundColor: 'mask.black.20p',
              '&:hover, &:focus': {
                  backgroundColor: 'mask.white.8p',
              },
          }
        : {
              '&:hover, &:focus': {
                  backgroundColor: DS_COLOR.GREY,
              },
          }),
});

const styleIconButton = (isDarkMode: boolean) => ({
    ...(isDarkMode
        ? {
              backgroundColor: 'mask.black.20p',
              '&:hover, &:focus': {
                  backgroundColor: 'mask.white.8p',
              },
          }
        : {
              backgroundColor: 'white',
              '&:hover, &:focus': {
                  backgroundColor: DS_COLOR.GREY,
              },
          }),
});

export function InvertedButton({ sx, ...props }: ButtonProps) {
    const {
        palette: { mode },
    } = useTheme();
    const isDarkMode = mode === 'dark';
    const invertedTheme = useProvidedTheme(isDarkMode ? 'light' : 'dark');

    return (
        <ThemeProvider theme={invertedTheme}>
            <Button
                variant="contained"
                {...props}
                sx={sxAppend(styleButton(isDarkMode), sx)}
            />
        </ThemeProvider>
    );
}

export function InvertedIconButton({ sx, ...props }: IconButtonProps) {
    const {
        palette: { mode },
    } = useTheme();
    const isDarkMode = mode === 'dark';
    const invertedTheme = useProvidedTheme(isDarkMode ? 'light' : 'dark');

    return (
        <ThemeProvider theme={invertedTheme}>
            <IconButton
                {...props}
                sx={sxAppend(styleIconButton(isDarkMode), sx)}
            />
        </ThemeProvider>
    );
}
